export enum app {
  breakPoint = 770,
  higherBreakPoint = 1243,
  contactMeBreakPoint = 1629,
  productsSize = 5
}

export const i18nKeyPrefix = '';
